import type { SVGProps } from 'react';
const SvgIconDisclosureUp = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.192 10.878a.743.743 0 0 0 1.05.052L8 6.87l4.758 4.06a.744.744 0 0 0 .998-1.102L8.499 5.07a.743.743 0 0 0-.998 0L2.245 9.828a.743.743 0 0 0-.053 1.05"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgIconDisclosureUp;
